import React, { useState, useEffect } from 'react';
import BonusItemsPopup from './BonusItemsPopup';

const GlobalPopups = () => {
  const [showBonusPopup, setShowBonusPopup] = useState(false);

  useEffect(() => {
    // Check if user has already seen the popup today
    const lastShown = localStorage.getItem('bonusPopupLastShown');
    const today = new Date().toDateString();
    
    if (lastShown !== today) {
      // Show popup after 10 seconds
      const timer = setTimeout(() => {
        setShowBonusPopup(true);
        localStorage.setItem('bonusPopupLastShown', today);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseBonusPopup = () => {
    setShowBonusPopup(false);
  };

  return (
    <>
      {showBonusPopup && <BonusItemsPopup onClose={handleCloseBonusPopup} />}
    </>
  );
};

export default GlobalPopups;